import axios from "axios";
import {APIError, validateError} from "../../common/utils/errors";
import LS from "local-storage";
import eventBus from "../../common/utils/eventBus";

const http = axios.create({
    baseURL: global.API_URI || "",
})

http.interceptors.response.use(function (resp) {

    const json = resp.data || {};
    if (!json.status && json.error) {
        const msg = json.error.msg || '';
        const code = json.error.code || 0;
        if (json.error.validate) {
            return Promise.reject(new validateError(msg, code, json.error.validate))
        }

        const error = new APIError(msg, code);
        eventBus.$emit('error', error);
        return Promise.reject(error)
    }

    return Promise.resolve(resp.data);
});

export default {
    register(regInfo) {
        return http.post('/register',regInfo)
    },

    login(loginInfo) {
        return http.post('/login',loginInfo)
    },

    activate(hash) {
        return http.post('/activate/email',{hash})
    },

    activateEmailResend() {
        const token = LS.get('token');
        return http.post('/activate/email/resend', {}, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        })
    },

    sendForgetPwdEmail(userInfo){
        return http.post('/member/forgot-pwd/email',userInfo)
    }
}